import { useChatbotSettingsStore } from 'store/useChatbotSettingsStore'

export const PoweredBy = () => {
  const { chatbot } = useChatbotSettingsStore()

  const url = new URL('https://outcast.ai')
  const params = new URLSearchParams()

  if (chatbot?.referral_code) {
    params.append('via', chatbot.referral_code)
  }

  params.append('utm_source', `chatbot-id-${chatbot?.id}`)
  params.append('utm_medium', 'chatbot')
  params.append('utm_campaign', 'powered-by')

  url.search = params.toString()
  return (
    <div className=" mb-2 border-t border-slate-200 bg-slate-100 px-4 sm:mb-0">
      <div className="flex items-center justify-center p-2">
        <p className="mr-1 text-xs text-gray-400">Powered by</p>
        <a href={url.toString()} target="_blank" rel="noopener noreferrer">
          <p
            className="text-xs font-bold"
            style={{
              color: chatbot?.theme_color || '#3a85ff',
            }}
          >
            Outcast.ai
          </p>
        </a>
      </div>
    </div>
  )
}
